import {
  GatewayMerchantResolver,
  SearchBar,
  SectionSubheader,
  SwitchAppButton,
  SwitchAppContentSwitcher,
  SwitchAppIconButton,
} from "../../../../../components";
import {
  HookFormCheckbox,
  HookFormSelect,
  SubmitButton,
  TextInput,
} from "../../../../../hook-form";
import { filterSupportedCountriesFromList } from "../../../../../utils";
import {
  ISingleTransferViewProps,
  TNewOrBeneficiaryRecipient,
} from "./SingleGatewayTransferForm";
import { countries, currencies } from "../../../../../constants";
import closeIconRed from "../../../../../assets/icons/close-circle-red.svg";
import { GatewayBeneficiariesTableHeader } from "./GatewayBeneficiariesTableHeader";
import { DevTool } from "@hookform/devtools";
import { GatewayBeneficiaryListItem } from "./GatewayBeneficiaryListItem";
import { GatewayBeneficiarySkeleton } from "./GatewayBeneficiarySkeleton";

export const View = ({
  navigateToBatchList,
  isBatchEditMode,

  beneficiaries,
  isLoadingBeneficiaries,
  setSearchBeneficiaryText,
  newOrBeneficiaryView,
  setNewOrBeneficiaryView,
  selectBeneficiary,
  clearSelectedBeneficiary,

  isLoadingSupportedCountries,
  swAppSupportedCountries,
  isLoadingSupportedCurrencies,
  swAppSupportedCurrencies,
  isLoadingSupportedGateways,
  supportedGateways,

  isGatewayMerchantResolved,
  setGatewayMerchantResolved,
  setResolvedGatewayMerchantDetails,

  formValues,
  isDirty,
  control,
  errors,
  handleSubmit,
  register,
}: ISingleTransferViewProps) => {
  const beneficiaryCountry = countries
    .find(
      (grp) =>
        grp.options.find((ctry) => ctry.value === formValues.country) !==
        undefined
    )
    ?.options.find((ctry) => ctry.value === formValues.country);

  // TODO: add a global context with supported countries and currencies
  // const currency = swAppSupportedCurrencies.find((cur) => cur.value === item.currency);
  const beneficiaryCurrency = currencies.find(
    (cur) => cur.value === formValues.currency
  );

  return (
    <form className="single-gateway-transfer--form" onSubmit={handleSubmit}>
      <div className="flex-container justify-content--between align-items--center row">
        <div className="flex-box">
          <SectionSubheader
            title={
              isBatchEditMode ? "UPDATE BATCH ENTRY" : "NEW TRANSFER RECIPIENT"
            }
            // className="search-section--header"
          />
        </div>

        <div className="d-md-none">
          <SwitchAppButton
            kind="danger"
            onClick={navigateToBatchList}
            size="sm"
            className="flex-box mt-5"
          >
            Back To List
          </SwitchAppButton>
        </div>
      </div>

      <div className="flex-container flex-break--small">
        <div className="flex-box">
          <TextInput
            name="reference"
            label="Reference"
            infoIconText="Unique reference for this transfer"
            type="text"
            register={register}
            errors={errors}
          />
        </div>
        {/* <div className="flex-box mr-md-5">xxxxxxxxxxxx</div> */}
      </div>

      <div className="flex-container flex-break--small">
        <div className="flex-box mt-5">
          <SwitchAppContentSwitcher<TNewOrBeneficiaryRecipient>
            onChange={({ name }) => {
              setNewOrBeneficiaryView(name);
            }}
            options={[
              {
                key: "SwitchApp Beneficiaries",
                value: "beneficiary",
              },
              {
                key: "New Transfer",
                value: "new",
              },
            ]}
            selectedValue={newOrBeneficiaryView}
          />
        </div>
      </div>

      {newOrBeneficiaryView === "new" ? null : (
        <div className="beneficiary-details--container mt-5">
          {formValues.beneficiary_id === null ? (
            <>
              <SearchBar
                name="search-beneficiaries"
                placeholder="Search beneficiaries..."
                onChange={(e: any) => setSearchBeneficiaryText(e.target.value)}
                onClear={() => setSearchBeneficiaryText("")}
                className="beneficiary-searchbar"
              />

              <div className="beneficiaries-list--container">
                <div className="cds--structured-list">
                  <GatewayBeneficiariesTableHeader />
                  <div className="mr-5 cds--structured-list-tbody cursor-pointer">
                    {!isLoadingBeneficiaries ? null : (
                      <>
                        <GatewayBeneficiarySkeleton />
                        <GatewayBeneficiarySkeleton />
                        <GatewayBeneficiarySkeleton />
                        <GatewayBeneficiarySkeleton />
                        <GatewayBeneficiarySkeleton />
                      </>
                    )}

                    {beneficiaries.map((benef, index) => (
                      <GatewayBeneficiaryListItem
                        beneficiary={benef}
                        selectBeneficiary={selectBeneficiary}
                        key={benef.id}
                      />
                    ))}
                  </div>
                </div>

                {isLoadingBeneficiaries || beneficiaries.length > 0 ? null : (
                  <div className="empty-transfers--list flex-container col justify-content--center align-items--center">
                    <div className="central--container flex-container col justify-content--center align-items--center">
                      <span className="pt-5">
                        {!setSearchBeneficiaryText
                          ? "No saved beneficiaries yet..."
                          : "No beneficiary was found for the search parameters..."}
                      </span>

                      <div className="pt-5">
                        <SwitchAppButton
                          kind="danger"
                          onClick={() => setNewOrBeneficiaryView("new")}
                          size="sm"
                          className="flex-box mt-5"
                        >
                          Transfer To New Recipient
                        </SwitchAppButton>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="selected-beneficiary-details">
              <div
                className="close-button--container"
                title="clear selected beneficiary"
              >
                <SwitchAppIconButton
                  size="sm"
                  kind="tertiary"
                  className="line-item--remove-button"
                  onClick={clearSelectedBeneficiary}
                >
                  <img
                    src={closeIconRed}
                    alt="close icon"
                    className="close-icon"
                  />
                </SwitchAppIconButton>
              </div>

              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">
                  Alias/Nickname:
                </span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues?.fullNameHelper}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">Country:</span>{" "}
                <strong className="font-ctm--extrabold">
                  {beneficiaryCountry?.text}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">Currency:</span>{" "}
                <strong className="font-ctm--extrabold">
                  {beneficiaryCurrency?.text}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">Gateway:</span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues.gatewayNameHelper}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">
                  Merchant Code:
                </span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues.merchant_id_or_code}
                </strong>
              </div>
              <div className="beneficiary-detail--row">
                <span className="text-secondary font-ctm--bold">
                  Merchant Name:
                </span>{" "}
                <strong className="font-ctm--extrabold">
                  {formValues.merchantNameHelper}
                </strong>
              </div>

              <div className="flex-container align-items--end bb-1">
                {isGatewayMerchantResolved ? (
                  <strong className="text-danger font-ctm--extrabold mr-3">
                    MERCHANT RESOLVED:
                  </strong>
                ) : null}
                <strong>
                  <GatewayMerchantResolver
                    merchantIdOrCode={formValues.merchant_id_or_code}
                    recipientGatewayCode={formValues.recipient_gateway_code}
                    country={formValues.country}
                    currency={formValues.currency}
                    isGatewayMerchantResolved={isGatewayMerchantResolved}
                    setGatewayMerchantResolved={setGatewayMerchantResolved}
                    setResolvedGatewayMerchantDetails={
                      setResolvedGatewayMerchantDetails
                    }
                  />
                </strong>
              </div>
            </div>
          )}

          <TextInput
            name="amount"
            label="Amount"
            infoIconText="Amount to transfer"
            type="number"
            register={register}
            errors={errors}
          />
        </div>
      )}

      {newOrBeneficiaryView === "beneficiary" ? null : (
        <div className="">
          {/* Causes pushing new page to prompt if form is dirty */}
          {/* {!isDirty ? null : 
          <PromptOnDirtyFormClose
            when={globalStore.isLoadingMainScreen}
            message={
              () => `Are you sure you want to leave this page?`
              // location => `Are you sure you want to go to ${location.pathname}`
            }
          />} */}

          <div className="flex-container flex-break--small">
            <div className="flex-box mr-md-5">
              <HookFormCheckbox
                name="save_as_beneficiary"
                label="Save As Beneficiary"
                checked={formValues.save_as_beneficiary || false}
                infoIconText="Save this recipient in your beneficiaries list"
                register={register}
                errors={errors}
              />
            </div>
          </div>

          {/* {!formValues.save_as_beneficiary ? null : (
            <div className="flex-container flex-break--small">
              <div className="flex-box">
                <TextInput
                  name="full_name"
                  label="Beneficiary Alias/Nickname (Optional)"
                  infoIconText="A name easier for you to identify the beneficiary (Optional)"
                  type="text"
                  register={register}
                  errors={errors}
                />
              </div>
            </div>
          )} */}

          {/* <div className="flex-container flex-break--small">
            <div className="flex-box">
              <HookFormSelect
                name="country"
                label="Country (Destination Bank)"
                infoIconText="Country where destination bank account is located"
                showSkeleton={isLoadingSupportedCountries}
                selectItems={[]}
                selectGroupedItems={filterSupportedCountriesFromList(
                  swAppSupportedCountries
                )}
                register={register}
                errors={errors}
              />
            </div>
          </div> */}

          <div className="flex-container flex-break--small">
            {/* NOTE: disabled b/c this will require currency conversions */}

            <div className="flex-box mr-md-5">
              <HookFormSelect
                name="currency"
                label="Currency (Destination Acc.)"
                infoIconText="The currency of the merchant account you want to transfer to eg NGN"
                showSkeleton={
                  !!formValues.country && isLoadingSupportedCurrencies
                }
                selectItems={swAppSupportedCurrencies.map((cur) => ({
                  text: `${cur.currency_name} (${cur.currency_symbol})`,
                  value: cur.currency,
                }))}
                register={register}
                errors={errors}
                // disabled={!formValues.xxxxxxxx}
              />
            </div>
            <div className="flex-box">
              <HookFormSelect
                name="recipient_gateway_code"
                label="Recipient Gateway"
                infoIconText="The gateway you want to transfer funds to"
                showSkeleton={isLoadingSupportedGateways}
                selectItems={supportedGateways.map((gw) => ({
                  text: gw.gateway_name,
                  value: gw.gateway_code,
                }))}
                register={register}
                errors={errors}
                disabled={!formValues.country || !formValues.currency}
              />
            </div>
          </div>

          <div className="flex-container flex-break--small">
            <div className="flex-box mr-md-5"></div>
            <div className="flex-box"></div>
          </div>

          <div className="flex-container flex-break--small">
            <div className="flex-box mr-md-5">
              <TextInput
                name="merchant_id_or_code"
                label="Recipient SwitchApp Handle"
                infoIconText="The recipient merchant's handle or Id on the payment gateway"
                type="text"
                register={register}
                errors={errors}
              />

              <div className="flex-container">
                <GatewayMerchantResolver
                  merchantIdOrCode={formValues.merchant_id_or_code}
                  recipientGatewayCode={formValues.recipient_gateway_code}
                  country={formValues.country}
                  currency={formValues.currency}
                  isGatewayMerchantResolved={isGatewayMerchantResolved}
                  setGatewayMerchantResolved={setGatewayMerchantResolved}
                  setResolvedGatewayMerchantDetails={
                    setResolvedGatewayMerchantDetails
                  }
                />
              </div>
            </div>
            <div className="flex-box">
              <TextInput
                name="amount"
                label="Amount"
                infoIconText="Amount to transfer"
                type="number"
                register={register}
                errors={errors}
              />
            </div>
          </div>
        </div>
      )}

      <TextInput
        name="description"
        label="Short Description (Optional)"
        infoIconText="A description of this transfer (Optional)"
        type="text"
        register={register}
        errors={errors}
      />

      <SubmitButton
        kind="success"
        size="sm"
        className="mt-5"
        showChildrenWithLoadingIcon
        disabled={!isGatewayMerchantResolved}
      >
        {isBatchEditMode ? "Save Changes" : "+ Add Transfer To List"}
      </SubmitButton>

      {/* set up the dev tool */}
      <DevTool control={control} />
    </form>
  );
};
